
import { Box } from "@mui/material";
import { DisenioPaginas } from "../../layout";
import { useUniMedidaQuery } from "../../../hooks";
import { BuscadorSoloValor, CargandoMedio, TablaUniMedida } from "../../components";



export const ListadoUnidadMedidas = () => {


    const { unimedidaListQuery, page, termino, chagePage, chageTermino } = useUniMedidaQuery()
  

    return (
        <DisenioPaginas titulo="Listado Unidad de Medidas" url="add/new/medidas">
            {(unimedidaListQuery.isLoading)
            ?   <CargandoMedio titulo="Cargando unidades de medida..." />
            :   <>
                <BuscadorSoloValor termino={termino} chageTermino={chageTermino} titulo='Buscar medida...' place='Buscar x nombre...'/>
                <TablaUniMedida data={unimedidaListQuery.data || []} chagePage={chagePage} page={page} />
                </>
            }

            <Box sx={{height:30}} />
        </DisenioPaginas>
    )

}

